<template>
  <div>
    <header-status />
    <div class="conteudo">
      <div class="mesgs">
        <div class="msg_history" v-chat-scroll>
          <chat-message v-for="(item, index) in events" :key="index" :item="item" />
        </div>
        <div class="type_msg">
          <div class="input_msg_write">
            <v-text-field
              label="Escreva sua messagem"
              type="text"
              v-model="mensagem"
              v-on:keyup.enter="sendMessage"
              append-icon="fas fa-paper-plane"
              @click:append="sendMessage"
            />
            <!--<v-btn class="mx-2" fab dark large color="primary" @click.native="sendMessage">
              <v-icon dark>fas fa-paper-plane</v-icon>
            </v-btn>-->
          </div>
        </div>
      </div>
    </div>
    <footer-page />
  </div>
</template>

<script>
import dayjs from "dayjs";
import { firebase } from "@firebase/app";
import { authService } from "../plugins/firebase";
export default {
  data: () => {
    return {
      fromId: "5mkcjCSXb2bg8taovDSv7meUHWh2",
      chatId: null,
      events: [],
      user: null,
      mensagem: ""
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      let config = {
        headers: {
          Authorization: "Bearer " + (await authService.validToken())
        }
      };
      if (USER) {
        this.user = USER;
      } else {
        await this.getUser(config);
      }

      this.getMessages();
    },
    getUser(config) {
      return this.$http
        .get(
          this.$SERVE +
            "/students/me?device_id=" +
            DeviceUUID.get() +
            "&device_name=" +
            DeviceUUID.parse().browser +
            "&platform=web",
          config
        )
        .then(response => {
          USER = response.data;
          this.user = USER;
          this.loading = false;
          if (USER["status_payment"] != "paid") {
            window.location.href = "/payment";
          }
        });
    },
    async getMessages() {
      const snp = await this.$db
        .collection("chats")
        .where("usersId", "array-contains", this.user.firebase_id)
        .limit(1)
        .get();
      console.log(snp, snp.length);
      if (snp.docs.length > 0) {
        this.chatId = snp.docs[0].id;
      } else {
        const doc = await this.$db.collection("chats").add({
          name: this.user.name,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          updateAt: firebase.firestore.FieldValue.serverTimestamp(),
          usersId: [this.user.firebase_id, this.fromId]
        });
        this.chatId = doc.id;
      }

      console.log(this.chatId);

      this.events = [];
      this.$db
        .collection("chatEvents")
        .orderBy("createdAt", "asc")
        .where("chatId", "==", this.chatId)
        .onSnapshot(querySnapshot => {
          console.log("this.events clear");
          querySnapshot.forEach(doc => {
            const i = this.events.findIndex(o => o.id == doc.id);
            const evt = {
              id: doc.id,
              ...doc.data(),
              time: this.formatTime(doc.data().createdAt)
            };
            if (i > -1) {
              this.events[i] = evt;
            } else {
              this.events.push(evt);
            }
          });

          /*if(this.first){
              this.scrollToBottom();
              this.first = false;
          }*/
        });
    },
    message(doc) {
      if (!doc) return {};
      return {};

      /*const m = await doc.get();
      console.log(m.data());
      return m.data();*/
    },
    formatTime(time) {
      if (!time) return;
      const dt = dayjs(time.toDate());
      return "em " + dt.format("DD/MM/YY HH:mm");
    },
    sendMessage(obj = {}) {
      //console.log('sendMessage');
      if (!obj.tipo && this.mensagem == "") return;
      const msg = {
        body: this.mensagem,
        from_id: this.fromId,
        enviado_por: "student",
        tipo: obj.tipo || "txt",
        imagem: obj.imagem || "",
        audio: obj.audio || "",
        video: obj.video || ""
      };

      this.mensagem = "";
      //this.scrollToBottom();
      this.$db
        .collection("messages")
        .add(msg)
        .then(doc => {
          console.log(doc);
          const event = {
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            content: doc,
            type: "message",
            chatId: this.chatId
          };

          return this.$db
            .collection("chatEvents")
            .add(event)
            .then(doc => {
              return this.$db
                .collection("chats")
                .doc(this.chatId)
                .update({
                  lastEvent: doc,
                  updateAt: firebase.firestore.FieldValue.serverTimestamp()
                });
            });
        })
        .catch(error => {
          console.error("Error adding document: ", error);
          alert("Ocorreu um erro ao enviar mensagem");
        });
    }
  }
};
</script>
